<form>
   <div class="sam-form-row">
      <label>{{ 'brick.brick-management.settings.category_common.brick_title' | translate }}</label>
      <div class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width">
         <input
            (input)="brickTitleChanged($event.target.value)"
            [value]="brickTitleSettingValue$ | async"
            [placeholder]="brickOriginalTitle$ | async"
            fxFlex="1 1 auto"
            kendoTextBox
         />
      </div>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick-management.settings.category_common.brick_scaling' | translate }}</label>
      <div>
         <kendo-slider
            class="k-form-field sam-form-control sam-form-control-full-width"
            [showButtons]="false"
            [fixedTickWidth]="10"
            [min]="15"
            [max]="200"
            [smallStep]="5"
            [value]="brickScaling$ | async"
            (valueChange)="brickScalingChanged($event)"
         >
         </kendo-slider>
         <div class="sam-margin-left" [style.margin-left]="'15px'" fxFlexAlign="center" fxFlex="1 1 auto">
            {{ brickScalingText$ | async }}
         </div>
      </div>
   </div>
</form>
